export default __webpack_public_path__ + "static/media/bx_bxl-instagram.7bb1f281.svg";